module.exports = "/_next/static/media/google-chrome-icon.73be4932.png";